var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
export class Reports {
  /**
   * Creates an instance of Reports.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof Reports
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetAccountReportRq_ _getAccountReportRq
   * @returns Promise<GetAccountReportRq_>
   * @memberof Reports
   */
  getAccountReport(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Reports/Accounts", "GET", "application/json; charset=UTF-8", "text/csv", options);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, isFile: true }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetClientRegistrationReportRq_ _getClientRegistrationReportRq
   * @returns Promise<GetClientRegistrationReportRq_>
   * @memberof Reports
   */
  getClientRegistrationReport(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Reports/ClientRegistrations", "GET", "application/json; charset=UTF-8", "text/csv", options);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, isFile: true }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetContactReportRq_ _getContactReportRq
   * @returns Promise<GetContactReportRq_>
   * @memberof Reports
   */
  getContactReport(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Reports/ContactReport", "GET", "application/json; charset=UTF-8", "text/csv", options);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, isFile: true }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetSubscriptionFeedbackReportRq_ _getSubscriptionFeedbackReportRq
   * @returns Promise<GetSubscriptionFeedbackReportRq_>
   * @memberof Reports
   */
  getSubscriptionFeedbackReport(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Reports/SubscriptionFeedbacks", "GET", "application/json; charset=UTF-8", "text/csv", options);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, isFile: true }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
